export default __webpack_public_path__ + "static/media/highlevel_logo.20c96923.png";